import SuperAdminHome from './SuperAdminHome';
import SuperAdminHOC from './SuperAdminHomeHOC';

export default SuperAdminHOC(SuperAdminHome);



// WEBPACK FOOTER //
// ./src/pages/SuperAdminHome/index.jsx